import { render, staticRenderFns } from "./EditOrderDetails.vue?vue&type=template&id=d01ca44e"
import script from "./EditOrderDetails.vue?vue&type=script&lang=js"
export * from "./EditOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./EditOrderDetails.vue?vue&type=style&index=0&id=d01ca44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports